// Challenges page — list of unlock-by-deed objectives. Each shows progress
// against its target and the captain/ship reward you'll earn for completing.
import { api } from '../api/client';
import { captainArt, shipArt } from './art';
let unmounted = false;
export function unmountChallenges() { unmounted = true; }
// Lookup tables for reward display names. Resolves "stormbringer" → "Captain
// Stormbringer", "manowar" → "Man-of-War", etc. Built from /api/progression.
const rewardNames = {
    captain: new Map(),
    ship: new Map(),
};
export async function renderChallenges(root, goToLobby) {
    unmounted = false;
    root.innerHTML = `
    <div class="page challenges-page">
      <header class="page-header">
        <button class="btn btn--ghost btn--icon" id="btn-back-lobby" title="Back to lobby">←</button>
        <h1 class="page-title">Challenges</h1>
      </header>
      <div class="challenges-loading">Loading…</div>
    </div>`;
    root.querySelector('#btn-back-lobby')?.addEventListener('click', goToLobby);
    let data;
    let prog;
    try {
        [data, prog] = await Promise.all([api.challenges(), api.progression()]);
    }
    catch (err) {
        root.querySelector('.challenges-loading').textContent = `Failed to load: ${err.message}`;
        return;
    }
    if (unmounted)
        return;
    for (const c of prog.captains)
        rewardNames.captain.set(c.id, c.name);
    for (const s of prog.ships)
        rewardNames.ship.set(s.id, s.name);
    const completed = data.challenges.filter((c) => c.completed);
    const inProgress = data.challenges.filter((c) => !c.completed);
    const page = root.querySelector('.challenges-page');
    page.innerHTML = `
    <header class="page-header">
      <button class="btn btn--ghost btn--icon" id="btn-back-lobby" title="Back to lobby">←</button>
      <h1 class="page-title">Challenges</h1>
      <div class="profile-greet">${completed.length} of ${data.challenges.length} cleared</div>
    </header>
    <p class="profile-blurb">Earn captains and ships by hitting these milestones across your matches. Progress tracks automatically.</p>
    <section class="challenge-section">
      <h2>Open</h2>
      ${inProgress.length === 0
        ? '<div class="empty">All challenges cleared. Master mariner.</div>'
        : `<div class="challenge-grid">${inProgress.map(challengeCard).join('')}</div>`}
    </section>
    ${completed.length > 0 ? `
      <section class="challenge-section">
        <h2>Cleared</h2>
        <div class="challenge-grid">${completed.map(challengeCard).join('')}</div>
      </section>` : ''}
  `;
    page.querySelector('#btn-back-lobby')?.addEventListener('click', goToLobby);
}
function challengeCard(c) {
    const pct = Math.min(100, Math.round((c.count / c.target) * 100));
    const reward = c.reward_kind === 'captain' ? captainArt(c.reward_id) : shipArt(c.reward_id);
    const map = c.reward_kind === 'captain' ? rewardNames.captain : rewardNames.ship;
    const rewardName = map.get(c.reward_id) ?? c.reward_id;
    return `
    <div class="challenge-card ${c.completed ? 'challenge-card--done' : ''}">
      <div class="challenge-reward">
        <div class="challenge-reward-art reward-art--${c.reward_kind}">${reward}</div>
        <div class="challenge-reward-label">
          <span class="challenge-reward-kind">Reward: ${c.reward_kind}</span>
          <strong>${escape(rewardName)}</strong>
        </div>
      </div>
      <div class="challenge-body">
        <h3>${c.completed ? '✓ ' : ''}${escape(c.name)}</h3>
        <p>${escape(c.description)}</p>
        <em class="challenge-flavor">${escape(c.flavor)}</em>
        <div class="challenge-progress">
          <div class="challenge-progress-bar"><div class="challenge-progress-fill" style="width:${pct}%"></div></div>
          <div class="challenge-progress-label">${c.count} / ${c.target}${c.completed ? ' · cleared' : ''}</div>
        </div>
      </div>
    </div>
  `;
}
function escape(s) {
    return s.replace(/[&<>"']/g, (ch) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]));
}
